import { BaseTabInterface } from 'base';
import { BaseCustomerOfferTabsEnum } from '../../modules/inquiry/_enums/base-customer-offer-tabs.enum';

export const ASSIGNMENT_MENU: BaseTabInterface[] = [
  {
    id: BaseCustomerOfferTabsEnum.MaterData,
    title: 'masterData',
  },
  {
    id: BaseCustomerOfferTabsEnum.AssignmentInformation,
    title: 'externalEmployees.operationInfo.title',
  },
  {
    id: BaseCustomerOfferTabsEnum.Reviews,
    title: 'review',
  },
  {
    id: BaseCustomerOfferTabsEnum.WorkCouncil,
    title: 'workCouncil.label',
  },
  {
    id: BaseCustomerOfferTabsEnum.Documents,
    title: 'document.plural',
  },
  {
    id: BaseCustomerOfferTabsEnum.TimeRecordings,
    title: 'externalEmployees.timeRecordings.title',
  },
];
